var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 109,
    rx: 10,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0007 32.8596C41.8362 31.6724 42.9682 30.699 44.2962 30.0257C45.6242 29.3524 47.1072 29.0001 48.6135 29H60.3865C61.8928 29.0001 63.3758 29.3524 64.7038 30.0257C66.0318 30.699 67.1638 31.6724 67.9993 32.8596L70.4759 36.3811C70.7545 36.7766 71.1319 37.1009 71.5746 37.3252C72.0172 37.5494 72.5115 37.6667 73.0135 37.6667H75.85C78.2767 37.6667 80.6041 38.5798 82.32 40.2051C84.036 41.8304 85 44.0348 85 46.3333V72.3333C85 74.6319 84.036 76.8363 82.32 78.4616C80.6041 80.0869 78.2767 81 75.85 81H33.15C30.7233 81 28.3959 80.0869 26.68 78.4616C24.964 76.8363 24 74.6319 24 72.3333V46.3333C24 44.0348 24.964 41.8304 26.68 40.2051C28.3959 38.5798 30.7233 37.6667 33.15 37.6667H35.9865C36.4885 37.6667 36.9828 37.5494 37.4254 37.3252C37.8681 37.1009 38.2455 36.7766 38.5241 36.3811L41.0007 32.8596ZM48.4 57.8889C48.4 56.3565 49.0427 54.8869 50.1866 53.8034C51.3306 52.7198 52.8822 52.1111 54.5 52.1111C56.1178 52.1111 57.6694 52.7198 58.8134 53.8034C59.9573 54.8869 60.6 56.3565 60.6 57.8889C60.6 59.4212 59.9573 60.8909 58.8134 61.9744C57.6694 63.0579 56.1178 63.6667 54.5 63.6667C52.8822 63.6667 51.3306 63.0579 50.1866 61.9744C49.0427 60.8909 48.4 59.4212 48.4 57.8889ZM54.5 46.3333C51.2644 46.3333 48.1612 47.5508 45.8733 49.7179C43.5854 51.885 42.3 54.8242 42.3 57.8889C42.3 60.9536 43.5854 63.8928 45.8733 66.0599C48.1612 68.227 51.2644 69.4444 54.5 69.4444C57.7356 69.4444 60.8388 68.227 63.1267 66.0599C65.4146 63.8928 66.7 60.9536 66.7 57.8889C66.7 54.8242 65.4146 51.885 63.1267 49.7179C60.8388 47.5508 57.7356 46.3333 54.5 46.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.29636c4b2f7ae3c6e5115860379084a3.svg";
export { ForwardRef as ReactComponent };